import axios from 'axios';
import _ from 'lodash';

// Checks if a value exists
export function labelIsValid(data, value) {
  return (
    typeof(data[value]) !== 'object' 
    && data[value] !== '' 
    && data.hasOwnProperty(value)
  )
}

// Ensures that a game or fight is currently happening
export function isLive(env, data) {
  if (!_.isObject(data)) return

  if (env === 'GAME') {
    return data.gamescore.boxscore.gameinformation.gamestatus.status !== 'FINAL';
  } else {
    return data.LiveEvents[0].Fights.filter(el => el.FightStatus === '2').length !== data.LiveEvents[0].Fights.length;
  }
}

// Concatenates first and last name, and allows for `F. LastName` name format
export function combineNames(arr, first, last) {
  let newArr = [];
 
  if (arr === null || arr === '' || arr === undefined) return newArr;

  let fullname = (el) => {
    const firstname = _.get(el, first);
    const lastname = _.get(el, last);
    return firstname + (firstname.length === 1? '. ' : ' ') + lastname;
  }

  if (Array.isArray(arr[0]) && arr.length > 1) {
    for (let i = 0; i < arr.length; i++) {
      newArr.push(arr[i].map(el => Object.assign({ fullname: fullname(el) }, el)))
    }
  } else {
    arr = Array.isArray(arr) ? arr : [arr];
    newArr = arr.map(el => Object.assign({ fullname: fullname(el) }, el))
  }
  
  return newArr;
}

// Consolidates metadata into object to avoid change in 
// the index when being returned by the api
export function reduceMetadata(metadataArr) {
  return  _.reduce(metadataArr, (newMap, o) => {
    newMap[o.name] = o.value
    return newMap
  }, {})
}

// Returns index of the next scheduled game
export function nextGame(arr) {
  const nextGame = arr.filter(el => (el.schedule.gameTime + 3 * 60 * 60) * 1000 > Date.now())[0]
  return arr.indexOf(nextGame)
}

// Offsets timezone on a UTC timestamp, in milliseconds
export function offsetTimezone(time) {
  const offset = new Date(time).getTimezoneOffset() * 60 * 1000;
  return new Date(time + offset);
}

// Fetches games for the current year, reorganizes the structure
// to include the schedule, then flattens and sorts them by chronological order
export function getGames() {
  const beg = Math.floor(new Date(`January 01, ${new Date().getFullYear()}`).valueOf() / 1000);
  const end = Math.floor(new Date(`December 31, ${new Date().getFullYear()}`).valueOf() / 1000);
  const { internalName, apiBaseUrl } = window.settings;
  
  return axios.get(`${apiBaseUrl}/content/game/schedule?site=${internalName}&from=${beg}&to=${end}`)
  .then((res) => {
    const mapped = res.data.map(item => item.gist.gameSchedule.map((games) => 
      ({  'schedule': games, 
          'homeTeam': item.gist.homeTeam.gist, 
          'awayTeam': item.gist.awayTeam.gist,
          'ticket': item.gist.ticketUrl, 
          'stream': item.gist.livestreamUrl, 
          'dataId': item.gist.dataId,
          'link': item.gist.permalink 
      })
    ))
    const flatten = _.flatten(mapped);
    const sorted = flatten.sort((a, b) => a.schedule.gameTime - b.schedule.gameTime);
    return sorted;
  }).catch((err) => {
    console.log(err);
  })
}

// Given a timestamp in milliseconds, returns an object with different
// methods to obtain the interval between Date.now() and that timestamp
export function getDuration(diffInMill) {
  let diff = diffInMill / 1000;
  let days = Math.floor(diff / 86400);
  let hours = Math.floor((diff - (days * 86400)) / 3600);
  let minutes = Math.floor((diff - (hours * 3600) - (days * 86400)) / 60);
  let seconds = Math.floor(diff - (minutes * 60) - (hours * 3600) - (days * 86400));

  return {
    getDays() {
      return days < 10? '0'+days : days;
    },
    getHours() {
      return hours < 10? '0'+hours : hours;
    },
    getMinutes() {
      return minutes < 10? '0'+minutes : minutes;
    },
    getSeconds() {
      return seconds < 10? '0'+seconds : seconds;
    }
  }
}